import { Link } from 'react-router-dom';

export function Button({
		children,
		icon,
		iconPlacement,
		role,
		target,
		to
	}) {
		
	if(!role) {
		role = "primary"
	}
	
	if(!iconPlacement) {
		iconPlacement = 'before';
	}
	
	var svg = null;
		
	switch(icon) {
		case 'arrow-right':
			svg = (<><svg className="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M14.6875 8.71875L9.6875 13.7188C9.5 13.9062 9.25 14 9 14C8.71875 14 8.46875 13.9062 8.28125 13.7188C7.875 13.3438 7.875 12.6875 8.28125 12.3125L11.5625 9H2C1.4375 9 1 8.5625 1 8C1 7.46875 1.4375 7 2 7H11.5625L8.28125 3.71875C7.875 3.34375 7.875 2.6875 8.28125 2.3125C8.65625 1.90625 9.3125 1.90625 9.6875 2.3125L14.6875 7.3125C15.0938 7.6875 15.0938 8.34375 14.6875 8.71875Z" fill="white"/></svg></>)
			break;
		case 'external':
			svg = (<><svg className="icon" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M8 1.5C8 0.96875 8.4375 0.5 9 0.5H12.9688C13.125 0.5 13.25 0.53125 13.375 0.59375C13.4688 0.625 13.5938 0.71875 13.6875 0.8125C13.875 1 13.9688 1.25 14 1.5V5.5C14 6.0625 13.5312 6.5 13 6.5C12.4375 6.5 12 6.0625 12 5.5V3.9375L6.6875 9.21875C6.3125 9.625 5.65625 9.625 5.28125 9.21875C4.875 8.84375 4.875 8.1875 5.28125 7.8125L10.5625 2.5H9C8.4375 2.5 8 2.0625 8 1.5ZM0 3.5C0 2.40625 0.875 1.5 2 1.5H5C5.53125 1.5 6 1.96875 6 2.5C6 3.0625 5.53125 3.5 5 3.5H2V12.5H11V9.5C11 8.96875 11.4375 8.5 12 8.5C12.5312 8.5 13 8.96875 13 9.5V12.5C13 13.625 12.0938 14.5 11 14.5H2C0.875 14.5 0 13.625 0 12.5V3.5Z" fill="#1C1E21"/>
				</svg></>)
			break;
	}
		
	return(
		<>
			{to ? (
				<Link 
					className={`button${role && ` ${role}`}`}
					target={target}
					to={to}
					>
					{iconPlacement === 'before' && (			
						<>{svg}</>
					)}
					{children}
					{iconPlacement === 'after' && (			
						<>{svg}</>
					)}
				</Link>
			) : (
				<Button className={`${role && role}`}>{children}</Button>
			)}
		</>
	)
}